import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const tabContent = ({ theme }: { theme: Theme }) => css`
  padding: ${theme.spacing(2)};
`
